import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import useFetch from '../../../api/useFetch';
import { t } from 'i18next';
import { createElement, useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import TypeText from './TypeText';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';

const TypeMeeting = ({
  field,
  dataCollection,
  errors = {},
  updateValidationOnChange,
  size = 'small',
  onFocus,
  onBlur,
}) => {
  const cookies = new Cookies();
  const current = new Date();
  const nextYear = new Date();
  nextYear.setFullYear(current.getFullYear() + 1);

  const rememberedMeetingType = cookies.get('meetingType');
  const { apiData, setApiData } = useFetch(`integrations`);

  useEffect(() => {
    if (apiData) {
      const google = apiData.data.find((el) => el.type === 'googleCalendar');
      if (google) {
        const filteredData = apiData.data.filter(
          (el) => el.type !== 'googleCalendar'
        );
        const newGoogle = { ...google, type: 'googleMeet' };
        const newData = [...filteredData, newGoogle];
        setApiData({ data: newData });
      }
    }
  }, [apiData]);

  const autoGeneratedTypes = ['zoom', 'teams', 'googleMeet'];

  function handleChange(e) {
    if (e.target.value === dataCollection[field.key]?.type) return;
    const newType = e.target.value;

    updateValidationOnChange([field.key], {
      type: newType,
      url: autoGeneratedTypes.includes(newType)
        ? t('Is generated automatically')
        : '',
    });

    cookies.set('meetingType', newType, {
      path: '/',
      expires: nextYear,
    });
  }

  const providerMap = {
    zoom: Zoom,
    googleMeet: GoogleMeet,
    teams: Teams,
    custom: Custom,
  };

  return (
    <Box className="flex gap-2">
      <FormControl
        className="w-[160px]"
        sx={{
          height: size === 'small' ? '40px' : '53px',
        }}
      >
        <InputLabel id="meeting-provider-label" size={size}>
          {t('Provider')}
        </InputLabel>
        <Select
          labelId="meeting-provider-label"
          value={
            dataCollection[field.key]
              ? dataCollection[field.key].type || 'custom'
              : rememberedMeetingType
          }
          onChange={handleChange}
          sx={{
            height: size === 'small' ? '40px' : '53px',
          }}
        >
          <MenuItem value="custom">
            {createElement(providerMap['custom'], { size })}
          </MenuItem>
          {apiData?.data.map(
            (obj) =>
              providerMap[obj.type] && (
                <MenuItem
                  key={obj.id}
                  value={obj.type}
                  disabled={obj.actionRequired}
                  className="flex flex-col"
                >
                  {createElement(providerMap[obj.type], {
                    size,
                    actionRequired: obj.actionRequired,
                  })}
                  {obj.actionRequired && (
                    <Typography variant="h6" fontSize={9}>
                      {t('You must link your account in your profile!')}
                    </Typography>
                  )}
                </MenuItem>
              )
          )}
        </Select>
      </FormControl>

      <Box className="w-full flex flex-col">
        <TypeText
          dataCollection={dataCollection[field.key] || { url: '' }}
          field={{
            label: t('Url'),
            key: 'url',
            colspan: 1,
            disabled: autoGeneratedTypes.includes(
              dataCollection[field.key]
                ? dataCollection[field.key].type
                : rememberedMeetingType
            ),
          }}
          size={size}
          updateValidationOnChange={(key, value) => {
            updateValidationOnChange([field.key], {
              ...dataCollection[field.key],
              url: value,
            });
          }}
        />
      </Box>
    </Box>
  );
};

export const Zoom = ({ size, actionRequired }) => {
  const iconPath = '/assets/meeting-provider/zoom-logo.svg';

  return (
    <Box
      className="rounded-full flex items-center justify-center w-full "
      sx={{ height: '25px' }}
    >
      <img src={iconPath} style={{ height: '60%' }} />
    </Box>
  );
};

export const GoogleMeet = ({ size, actionRequired }) => {
  const iconPath = '/assets/meeting-provider/meet-logo.svg';

  return (
    <Box
      className="rounded-full flex items-center justify-center w-full"
      sx={{ height: '25px' }}
    >
      <img src={iconPath} style={{ height: '100%' }} />
    </Box>
  );
};

export const Teams = ({ size }) => {
  const iconPath = '/assets/meeting-provider/teams-logo.png';

  return (
    <Box
      className="rounded-full flex items-center justify-center w-full"
      sx={{ height: '25px' }}
    >
      <img
        src={iconPath}
        style={{ height: '90%' }}
        className=" object-contain"
      />
    </Box>
  );
};

export const Custom = ({ size }) => {
  return (
    <Box
      className="rounded-full flex items-center justify-center w-full gap-2"
      sx={{ height: '25px' }}
    >
      <VideoCameraFrontIcon />
      <Typography>{t('Url')}</Typography>
    </Box>
  );
};

export default TypeMeeting;
